import React from "react";
import { Form, DatePicker } from "antd";

export function InputMonth(props) {

  return (
    <Form.Item
      name={props.name}
      label={props.label}
      initialValue={props.defaultValue}
      rules={[
        {
          required: props.required,
          message: props.errorMessage
        }
      ]}
    >
      <DatePicker
        format={props.format}
        picker="month"
        allowClear={props.allowClear}
        dateRender={props.dateRender}
        // nextIcon={props.nextIcon}
        // prevIcon={props.prevIcon}
        size={props.size}
        // suffixIcon={props.suffixIcon}
        placeholder={props.placeholder}
        onChange={props.onChange}
        style={props.style}
      />
    </Form.Item>
  )
}